export const useNotificationPermission = () => {
  const isAvailable = window !== undefined && window.Notification !== undefined;

  const requestPermission = () => Notification.requestPermission();
  const isGranted = () => window?.Notification?.permission === "granted";
  const isDenied = () => window?.Notification?.permission === "denied";
  const isPrompt = () => window?.Notification?.permission === "default";

  return {
    isAvailable,
    isDenied,
    isGranted,
    isPrompt,
    requestPermission,
  };
};
